export default __webpack_public_path__ + "static/featured_image_og_codilime_newsletter-d04a9835f75d082481a93bceb5066ff4.jpg";